import LABEL from '../../../business-const/Label/Label'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import {
    TextValidatorText,
    TextValidatorNumber,
    TextValidatorNumberRequired,
    TextValidatorValor,
} from '../../../business-components/TextValidator/TextValidator'



export const IdadeInicial = ({ values, item, ind, handleChange }) => {

    const TextValidatorIdadeInicial = item.aporteMensal || item.retiradaMensal ? TextValidatorNumberRequired : TextValidatorNumber

    return (
        <TextValidatorIdadeInicial
            name={`aporteRetiradaMensal[${ind}].idadeInicial`}
            label={LABEL.idadeInicial}
            value={item.idadeInicial === 0 ? 0 : item.idadeInicial || ''}
            onChange={handleChange}
            numMin={values.idadeDataSimulacaoCliente}
            numMax={values.idadeFinalVitalicioClienteConjuge}
        />
    )
}

export const IdadeFinal = ({ values, item, ind, handleChange }) => {

    const TextValidatorIdadeFinal = item.aporteMensal || item.retiradaMensal ? TextValidatorNumberRequired : TextValidatorNumber

    return (
        <TextValidatorIdadeFinal
            name={`aporteRetiradaMensal[${ind}].idadeFinal`}
            label={LABEL.idadeFinal}
            value={item.idadeFinal === 0 ? 0 : item.idadeFinal || ''}
            onChange={handleChange}
            numMin={values.idadeDataSimulacaoCliente}
            numMax={values.idadeFinalVitalicioClienteConjuge}
        />
    )
}

export const AporteMensal = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorValor
            name={`aporteRetiradaMensal[${ind}].aporteMensal`}
            label={LABEL.aporteMensal}
            value={item.aporteMensal || ''}
            onChange={handleChange}
        />
    )
}

export const RetiradaMensal = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorValor
            name={`aporteRetiradaMensal[${ind}].retiradaMensal`}
            label={LABEL.retiradaMensal}
            value={item.retiradaMensal || ''}
            onChange={handleChange}
        />
    )
}

export const Observacao = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorText
            name={`aporteRetiradaMensal[${ind}].observacao`}
            label={LABEL.observacao}
            value={item.observacao || ''}
            onChange={handleChange}
            tamMax={TAMMAX.observacao}
        />
    )
}